<template>
	<div :class="$style.heading">
		<div :class="$style.tabs">
			<div
				v-for="tab in tabs"
				:key="tab.key"
				:class="[
					$style.tab,
					modelValue !== tab.key && 'ao-text-secondary-color-700',
					modelValue === tab.key && $style.active,
				]"
				:value="tab.key"
				@click="modelValue = $emit('update:modelValue', tab.key)"
			>
				<span class="ao-p3-medium">{{ tab.text }}</span>
			</div>
		</div>
		<!-- <ao-icon-btn
			iconName="sizeMx"
			size="24"
			variant="text"
			:class="$style.wide_icon"
			@click="handleToggleWide"
		/> -->
	</div>

	<div :class="[$style.content, wide && $style.wide]">
		<slot/>
		<!-- <ao-icon
			iconName="close"
			:class="$style.close_icon"
			@click="handleToggleWide"
		/> -->
	</div>
</template>

<script>
export default {
	name: 'PassportTabs',
	props: {
		modelValue: {
			type: String,
			default: null,
		},
		tabs: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			wide: false,
		}
	},
	methods: {
		handleToggleWide() {
			this.wide = !this.wide
		},
	},
}
</script>

<style module lang="scss">
.heading {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.tabs {
	display: flex;
	align-items: center;
}

.tab {
	padding: 8px 12px;
	cursor: pointer;
}

.tab.active {
	border-radius: 6px 6px 0 0;
	background: white;
}

.content {
	width: 100%;
	background: white;
	padding: 8px;
}

.close_icon {
	position: absolute;
	top: 8px;
	right: 8px;
	cursor: pointer;
}

.wide_icon {
	border: 1px solid #d9e3ee;
	font-size: 12px;
	border-radius: 4px;
}

.content.wide {
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 10000;
}
</style>
